import React from 'react';
import Modal from 'react-bootstrap/Modal';
import InputField from '../Reusable/InputField';
import { handleErrorMessage } from '../../utils';
import ButtonSave from '../Reusable/ButtonSave';
import withTranslations from '../../utils/HighOrderComponent';

class ModalForCreateRequestApprovalReferenceNumber extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      referenceNumber: '',
      errors: {},
    };
  }

  componentDidMount() {
    this.setState({
      referenceNumber: this.props.requestForSignetApproval.referenceNumber
        ? this.props.requestForSignetApproval.referenceNumber
        : '',
    });
  }

  handleClose = () => {
    this.props.handleClose();
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleClientValidation = () => {
    let hasError = false;

    let errors = {};

    if (!this.state.referenceNumber) {
      errors['referenceNumber'] = this.props.t.Errors.referenceNumber;
      hasError = true;
    }

    this.setState({ errors });
    return hasError;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.handleClientValidation()) {
      return;
    }

    const requestWithNewReferenceNumber = {
      requestForSignetApproval: {
        ...this.props.requestForSignetApproval,
      },
      referenceNumber: this.state.referenceNumber,
    };

    this.props.handleAdd(requestWithNewReferenceNumber);
  };

  render() {
    const { error, t } = this.props || {},
      { Labels } = t || {};

    return (
      <Modal
        show={this.props.show}
        onHide={this.handleClose}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Body>
            <h5 className="title">
              {this.props.requestForSignetApproval.referenceNumber
                ? Labels.titleUpdate
                : Labels.title}
            </h5>
            <form noValidate onSubmit={this.handleSubmit}>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <InputField
                    name="referenceNumber"
                    placeholder={
                      this.props
                        ? t.Placeholders.referenceNumberForPreview
                        : t.Placeholders.referenceNumber
                    }
                    multiple={false}
                    required={!this.props.signal}
                    onChange={this.onChange}
                    value={
                      this.props.signal
                        ? this.props.complementRequestApproval?.referenceNumber
                        : this.state.referenceNumber
                    }
                    error={handleErrorMessage(
                      error,
                      'referenceNumber',
                      this.state.errors.referenceNumber
                    )}
                    disabled={this.props.signal}
                  />
                </div>
              </div>
              {!this.props.signal && (
                <div className="row">
                  <ButtonSave onClick={this.handleSubmit} />
                </div>
              )}
            </form>
          </Modal.Body>
        </Modal.Header>
      </Modal>
    );
  }
}

export default withTranslations(
  ModalForCreateRequestApprovalReferenceNumber,
  'ModalForCreateRequestApprovalReferenceNumber'
);
